import { Typography } from '@mui/material'
import React from 'react'
import FlexBox from '../../flexBox/FlexBox'
import { ButtonGroupProps } from './_props'
import sxs from './_sxs'

const ButtonGroup: React.FC<ButtonGroupProps> = ({ label, children }) => (
    <FlexBox sx={sxs.wrapper} flexDirection="column">
        {label && <Typography sx={sxs.label}>{label}</Typography>}
        <FlexBox alignItems="center" sx={sxs.container}>
            {children}
        </FlexBox>
    </FlexBox>
)

export default ButtonGroup
